// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","245":"component---src-pages-index-tsx","735":"component---src-pages-coscreen-name-invite-code-tsx"}[chunkId] || chunkId) + "-" + {"108":"14c060cf1d3bd0b2bca5","223":"e157c3748b5b36c3a102","245":"ffaad9d2dc5f16db1339","452":"2dcfda8a3c505ddd9690","735":"ca72d05028b309575416"}[chunkId] + ".js";
};